import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Импортируем переводы
import ruTranslations from './locales/ru/translation.json';
import enTranslations from './locales/en/translation.json';
import ttTranslations from './locales/tt/translation.json';
import frTranslations from './locales/fr/translation.json';
import ptTranslations from './locales/pt/translation.json';
import hiTranslations from './locales/hi/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      ru: { translation: ruTranslations },
      en: { translation: enTranslations },
      tt: { translation: ttTranslations },
      fr: { translation: frTranslations },
      pt: { translation: ptTranslations },
      hi: { translation: hiTranslations }
    },
    fallbackLng: 'ru',
    
    interpolation: {
      escapeValue: false
    },
    
    detection: {
      // Порядок определения языка
      order: ['localStorage', 'navigator', 'htmlTag', 'querystring', 'cookie'],
      
      // Ключи для localStorage и cookie
      lookupLocalStorage: 'i18nextLng',
      lookupCookie: 'i18next',
      lookupQuerystring: 'lng',
      lookupFromPathIndex: 0,
      lookupFromSubdomainIndex: 0,
      
      // Кэширование
      caches: ['localStorage'],
      excludeCacheFor: ['cimode'],
      
      // Настройки cookie
      cookieMinutes: 10,
      cookieDomain: 'myDomain'
    },
    
    react: {
      useSuspense: false
    }
  });

export default i18n;